import { Injectable, OnDestroy, Signal } from "@angular/core";
import { loadKey } from "./models/loadKey";
import { _BaseLoadingService } from "./_base-loading.service";

@Injectable({
    providedIn: 'root'
})
export class AnimationService
    extends _BaseLoadingService
{
    isAnimating$$: Signal<boolean>;

    constructor() {
        super(loadKey.animating);
        this.isAnimating$$ = this.isLoading$$;
    }

    add(): void {
        super._add();
    }

    addCount(value: number): void {
        super._addCount(value);
    }

    clear(): void {
        super._clear();
    }

    remove(): void {
        super._remove();
    }

    removeCount(value: number): void {
        super._removeCount(value);
    }

    reset(): void {
        super._clear();
    }
}
